<template>
  <div class="col-sm-12 col-md-6 col-lg-4">
    <div class="element-wrapper">
      <h6 class="element-header">{{ t('profileChangePass', 'profileChangePass')}}</h6>
      <div class="element-box">
        <form id="formUpdatePass" v-on:submit.prevent="updatePassword">
          <h5 class="form-header"><i class="os-icon os-icon-unlock"></i> {{ t('profileChangePass', 'profileChangePass')}}</h5>
          <hr>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="oldPass">* {{ t('profileChangePassOldLabel', 'profileChangePassOldLabel') }}</label>
                <input id="oldPass" name="oldPass" v-model="oldPass" class="form-control" data-minlength="6" :placeholder="t('profileChangePassOldPlaceholder', 'profileChangePassOldPlaceholder')" required="required" type="password">
              </div>
            </div>
            <div class="col-sm-6" v-if="allTemplateDetails.allow_password_hints == 1">
              <div class="form-group">
                <label for="passHint">{{ t('profileChangePassHintLabel', 'profileChangePassHintLabel') }}</label>
                <input id="passHint" name="passHint" v-model="passHint" class="form-control" :placeholder="t('profileChangePassHintPlaceholder', 'profileChangePassHintPlaceholder')" type="text" autocomplete="off">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newPass">* {{ t('profileChangePassNewLabel', 'profileChangePassNewLabel') }}</label>
                <input id="newPass" name="newPass" v-model="newPass" class="form-control" data-minlength="6" :placeholder="t('profileChangePassNewPlaceholder', 'profileChangePassNewPlaceholder')" required="required" type="password" @input="checkPassword">
                <password v-model="newPass" :placeholder="'New password'" :strength-meter-only="true" />
                <div class="form-group password-checks">
                  <!--<p class="check-block" v-if="getPasswordPolicy.clientMinPasswordLength">
                    <ul class="check-list">
                      <li v-if="this.minLengthCorrect">
                        <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" />{{ t('passMinLengthFulfilled', 'passMinLengthFulfilled') }} {{ getPasswordPolicy.clientMinPasswordLength }}</span>
                      </li>
                      <li v-if="!this.minLengthCorrect">
                        <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" />{{ t('passMinLengthRequired', 'passMinLengthRequired') }} {{ getPasswordPolicy.clientMinPasswordLength }}</span>
                      </li>
                    </ul>
                  </p>
                  <p class="check-block" v-if="getPasswordPolicy.clientMaxPasswordLength">
                    <ul class="check-list">
                      <li v-if="this.maxLengthCorrect">
                        <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" />{{ t('passMaxLengthFulfilled', 'passMaxLengthFulfilled') }} {{ getPasswordPolicy.clientMaxPasswordLength }}</span>
                      </li>
                      <li v-if="!this.maxLengthCorrect">
                        <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" />{{ t('passMaxLengthAllowed', 'passMaxLengthAllowed') }} {{ getPasswordPolicy.clientMaxPasswordLength }}</span>
                      </li>
                    </ul>
                  </p>-->
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="newPassConfirm">* {{ t('profileChangePassConfirmLabel', 'profileChangePassConfirmLabel') }}</label>
                <input id="newPassConfirm" name="newPassConfirm" v-model="newPassConfirm" class="form-control" :placeholder="t('profileChangePassConfirmLabel', 'profileChangePassConfirmLabel')" required="required" type="password">
              </div>
            </div>
          </div>
          <div class="col-12">
            <p class="check-block" v-if="getPasswordPolicy.clientMinPasswordLength">
              <ul class="check-list">
                <li v-if="this.minLengthCorrect">
                  <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" />{{ t('passMinLengthFulfilled', 'passMinLengthFulfilled') }} {{ getPasswordPolicy.clientMinPasswordLength }}</span>
                </li>
                <li v-if="!this.minLengthCorrect">
                  <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" />{{ t('passMinLengthRequired', 'passMinLengthRequired') }} {{ getPasswordPolicy.clientMinPasswordLength }}</span>
                </li>
              </ul>
            </p>
            <p class="check-block" v-if="getPasswordPolicy.clientPasswordRequireDigit == 1">
              <ul class="check-list">
                <li v-if="this.containsNumber">
                  <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" /> {{ t('passContainsDigit', 'passContainsDigit') }}</span>
                </li>
                <li v-if="!this.containsNumber">
                  <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" /> {{ t('passMustContainDigit', 'passMustContainDigit') }}</span>
                </li>
              </ul>
            </p>
            <p class="check-block" v-if="getPasswordPolicy.clientPasswordRequireCapital == 1">
              <ul class="check-list">
                <li v-if="this.containsUppercase">
                  <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" /> {{ t('passContainsUppercase', 'passContainsUppercase') }}</span>
                </li>
                <li v-if="!this.containsUppercase">
                  <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" /> {{ t('passMustContainUppercase', 'passMustContainUppercase') }}</span>
                </li>
              </ul>
            </p>
            <p class="check-block" v-if="getPasswordPolicy.clientPasswordRequireSpecial == 1">
              <ul class="check-list">
                <li v-if="this.containsSpecialCharacter">
                  <span class="condition-correct"><fontAwesomeIcon style="color: #10a010" :icon="['fas', 'check']" size="1x" /> {{ t('passContainsSpecial', 'passContainsSpecial') }}</span>
                </li>
                <li v-if="!this.containsSpecialCharacter">
                  <span class="condition-failed"><fontAwesomeIcon style="color: red;" :icon="['fas', 'times']" size="1x" /> {{ t('passMustContainSpecial', 'passMustContainSpecial') }}</span>
                </li>
              </ul>
            </p>
          </div>
          <ResponseInfo v-if="getShowResponses.includes('showProfilePasswordResponse')"/>
          <ValidationErrors class="mb-3" v-if="getValidationErrors.validationName == 'UpdateProfilePassword'"></ValidationErrors>
          <div class="form-buttons-w"><button v-bind:class="{ disabled: !oldPass || !newPass || !newPassConfirm }" class="btn btn-primary" type="submit" value="submit">{{ t('profileUpdateButton', 'profileUpdateButton')}}</button></div>
        </form>
      </div>
    </div>
  </div> <!-- ENDOF Password change form -->
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import Password from 'vue-password-strength-meter'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default {
  name: 'ProfileFormPassword',
  data() {
    return {
      oldPass: '',
      newPass: '',
      newPassConfirm: '',
      passHint: '',
      minLengthCorrect: false,
      maxLengthCorrect: false,
      containsNumber: false,
      containsUppercase: false,
      containsSpecialCharacter: false
    }
  },
  methods: {
    updatePassword(){
      this.$store.dispatch('updatePassword',{
        oldPass: this.oldPass,
        newPass: this.newPass,
        newPassConfirm: this.newPassConfirm,
        passHint: this.passHint
      })

      this.oldPass = ''
      this.newPass = ''
      this.newPassConfirm = ''
      this.passHint = ''
      
      this.minLengthCorrect = false
      this.containsNumber = false
      this.containsUppercase = false
      this.containsSpecialCharacter = false
    }, 

    checkPassword() {
      // check password length to see if it follows the password policy
      this.minLengthCorrect = this.newPass.length >= this.$store.getters.getPasswordPolicy.clientMinPasswordLength
      this.maxLengthCorrect = this.newPass.length <= this.$store.getters.getPasswordPolicy.clientMaxPasswordLength
      // test function is used to search for character in the string ( digit, upper case )
      this.containsNumber = /\d/.test(this.newPass);
      this.containsUppercase = /[A-Z]/.test(this.newPass);
      this.containsSpecialCharacter = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.newPass)
    }
  },
  computed: {
      ...mapGetters(['allTemplateDetails', 'getShowResponses', 'getPasswordPolicy', 'getValidationErrors'])
  },
  components: {
    ResponseInfo,
    Password,
    ValidationErrors
  }
}
</script>

<style scoped>
  .condition-correct {
    color: #10a010;
    font-size: 12px;
  }
  .condition-failed {
    font-size: 12px;
    color: red;
  }
  .check-block {
    margin-bottom: 0px;
  }
  .check-list {
    margin-bottom: 0px; 
    padding-left: 0px;
  }
  ul {
    list-style-type: none;
  }
</style>
